export default (ms: number) => new Promise((res) => setTimeout(res, ms));
